import { StandardEntity } from '../../standard-entity';

export class QuickFactory {
  public generateProperty(item: any, o: any) {
    // tslint:disable-next-line:forin
    for (const attr in o) {
      if (item[attr] === undefined) {
        if (o[attr]) {
          if (o[attr] instanceof Array) {
            const array = o[attr];
            if (array.length > 0) {
              if (Object.hasOwn(array[0], 'id')) {
                item[attr] = o[attr].map(
                  (c) => new StandardEntity(c.id, c.label, 'label'),
                );
              } else {
                item[attr] = array;
              }
            } else {
              item[attr] = [];
            }
          } else if (
            typeof o[attr] === 'object' &&
            Object.hasOwn(o[attr], 'id')
          ) {
            item[attr] = new StandardEntity(o[attr].id, o[attr].label);
          } else {
            item[attr] = o[attr];
          }
        } else {
          item[attr] = o[attr];
        }
      }
    }
  }
}
